import { render, staticRenderFns } from "./salesPriceStrategy.vue?vue&type=template&id=5a06627f&scoped=true"
import script from "./salesPriceStrategy.vue?vue&type=script&lang=js"
export * from "./salesPriceStrategy.vue?vue&type=script&lang=js"
import style0 from "./salesPriceStrategy.vue?vue&type=style&index=0&id=5a06627f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a06627f",
  null
  
)

export default component.exports